export const staticSuffix = 'pdp';
export const micrositeName = 'yoda-microsite-pdp';
export const hostnames = {
    prod: 'm.jcpenney.com',
    preview: 'preview.jcpenney.com',
};

export const cachePolicy = {
    version: 1,
    enabled: true,
    minCache: 86400, // Value should be in seconds - Default 24 hours
    routeCache: {
        // Not supported yet
        match: '/p',
        minCache: 0,
        enabled: false,
    },
};

export const app = {
    logTag: 'MICROSITE:PDP',
};
export const configServerSettingsFlag = true;
export const micrositeSVG = true;
export const isContextHeadersRequired = null;
export const esiHeaderRequiredRoutes = null;
export const shallowFirstServerRendering = true;
